import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileNew"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.275 1.725C13.1413 1.57686 12.9495 1.49465 12.75 1.5H5.25C4.42157 1.5 3.75 2.17158 3.75 3V21C3.75 21.8284 4.42157 22.5 5.25 22.5H11.4563V21H5.25V3.00002H11.25V7.50002C11.25 8.32845 11.9216 9.00002 12.75 9.00002H17.25V13.2283H18.75V7.5C18.7554 7.30052 18.6731 7.10869 18.525 6.975L13.275 1.725ZM12.75 3.29999L16.95 7.49999H12.75V3.29999ZM17.25 18V15H15.75V18H12.75V19.5H15.75V22.5H17.25V19.5H20.25V18H17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileNew.vue"]]);
